import { z } from "zod";

export namespace BizShortlistModels {
  /**
   * BizShortlistResponseDtoSchema
   * @type { object }
   * @property { string } id
   * @property { string } bizUserId
   * @property { string[] } positions Array of position codes (e.g., ["11-3031", "13-2031"])
   * @property { string } createdAt
   * @property { string } updatedAt
   */
  export const BizShortlistResponseDtoSchema = z.object({
    id: z.string(),
    bizUserId: z.string(),
    positions: z.array(z.string()),
    createdAt: z.string(),
    updatedAt: z.string(),
  });
  export type BizShortlistResponseDto = z.infer<typeof BizShortlistResponseDtoSchema>;

  /**
   * AddPositionToShortlistDtoSchema
   * @type { object }
   * @property { string } positionCode Position code to add (e.g., "11-3031")
   */
  export const AddPositionToShortlistDtoSchema = z.object({ positionCode: z.string() });
  export type AddPositionToShortlistDto = z.infer<typeof AddPositionToShortlistDtoSchema>;
}
